import { datadogRum } from '@datadog/browser-rum'
import { useEffect } from 'react'

import { useFlag } from '~/shell/flags'

/**
 * Records a Session Replay for the session regardless of sampling when `atlas_force_session_replay_recording` is on.
 *
 * Renders nothing. Mounts below `RequireAuth`, which resolves flags first. A no-op when RUM was never initialized.
 */
export const ForcedSessionReplay = () => {
  const forced = useFlag('atlas_force_session_replay_recording')

  useEffect(() => {
    if (forced) {
      datadogRum.startSessionReplayRecording({ force: true })
    }
  }, [forced])

  return null
}
